import { IFormSelectOption } from '../forms/forms';

export const INSTRUCTION_TO_STAFF_OPTIONS = ['hasInvoice', 'openUp', 'alreadyCleared', 'gift', 'other', ''] as const;
export type InstructionToStaffOption = typeof INSTRUCTION_TO_STAFF_OPTIONS[number];

export const OPEN_SHIPMENT_OPTIONS = ['Opna-hafa samband', 'Opna-tollafgr', ''] as const;
type OpenShipmentOption = typeof OPEN_SHIPMENT_OPTIONS[number];

interface ISendReceipt {
	instructionsToStaff: InstructionToStaffOption;
	trackingNumbers: string[];
	foreignSsn: boolean;
	identificationNumber: string;
	name: string;
	phone: string;
	email: string;
	files: any[];
	hasReceipt: '' | 'Yes' | 'No';
	deliveryService: '0' | '1' | '2' | '3' | '4';
	additionalInformation: string;
	isCompany: boolean;
	openUp: OpenShipmentOption;
	giftType: IFormSelectOption | null;
	clearedTrackingNumber: string;
	acceptedTerms: boolean;
}

export interface ISendReceiptDTOResponse {
	error: boolean;
	errorMessage: string;
}

export default ISendReceipt;
